import { render, staticRenderFns } from "./PlantEditTab.vue?vue&type=template&id=1569c42e&"
import script from "./PlantEditTab.vue?vue&type=script&lang=js&"
export * from "./PlantEditTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports